import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getPercentage } from "../../resources/helper/helper";

export default function Compare() {
  const location = useLocation();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (location.state) {
      setProducts(location.state);
    }
  }, [location.state]);

  return (
    <div>
      <main className="main">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span /> Shop <span /> Compare
            </div>
          </div>
        </div>
        <div className="container mb-80 mt-50">
          <div className="row">
            <div className="col-xl-10 col-lg-12 m-auto">
              <h1 className="heading-2 mb-10">Products Compare</h1>
              <h6 className="text-body mb-40">
                There are{" "}
                <span className="text-brand">
                  {products && products?.length}
                </span>{" "}
                products to compare
              </h6>
              <div className="table-responsive">
                <table className="table text-center table-compare">
                  <tbody>
                    <tr className="pr_image">
                      <td className="text-muted font-sm fw-600 font-heading mw-200">
                        Preview
                      </td>
                      {products &&
                        products?.length > 1 &&
                        products?.map((item, index) => (
                          <td className="row_img" style={{ maxWidth: 200 }}>
                            <img src={item?.featured_media} alt="compare-img" />
                          </td>
                        ))}
                    </tr>

                    <tr className="pr_title">
                      <td className="text-muted font-sm fw-600 font-heading">
                        Name
                      </td>
                      {products &&
                        products?.length > 1 &&
                        products?.map((item, index) => (
                          <td
                            className="product_name"
                            key={index}
                            style={{ maxWidth: 200 }}
                          >
                            <h6>
                              <a className="text-heading">{item?.name}</a>
                            </h6>
                          </td>
                        ))}
                    </tr>
                    <tr className="pr_price">
                      <td className="text-muted font-sm fw-600 font-heading">
                        Price
                      </td>
                      {products &&
                        products?.length > 1 &&
                        products?.map((item, index) => (
                          <td className="product_price" key={index}>
                            <h4 className="price text-brand">
                              Rs. {item?.discount_price}
                            </h4>
                          </td>
                        ))}
                    </tr>
                    <tr className="pr_rating">
                      <td className="text-muted font-sm fw-600 font-heading">
                        Rating
                      </td>
                      {products &&
                        products?.length > 1 &&
                        products?.map((item, index) => (
                          <td key={index}>
                            <div className="rating_wrap">
                              <div className="product-rate d-inline-block">
                                <div
                                  className="product-rating"
                                  style={{
                                    width: `${getPercentage(
                                      item?.reviewsCount
                                    )}%`,
                                  }}
                                />
                              </div>
                              <span className="rating_num">{`(${item?.reviewsCount})`}</span>
                            </div>
                          </td>
                        ))}
                    </tr>
                    <tr className="description">
                      <td className="text-muted font-sm fw-600 font-heading">
                        Description
                      </td>
                      {products &&
                        products?.length > 1 &&
                        products?.map((item, index) => (
                          <td
                            className="row_text font-xs"
                            style={{ maxWidth: 200, padding: " 20px" }}
                            key={index}
                          >
                            <p className="font-sm text-muted">
                              {item?.description}
                            </p>
                          </td>
                        ))}
                    </tr>
                    <tr className="pr_stock">
                      <td className="text-muted font-sm fw-600 font-heading">
                        Stock status
                      </td>
                      {products &&
                        products?.length > 1 &&
                        products?.map((item, index) =>
                          item?.stock === 0 ? (
                            <td className="row_stock" key={index}>
                              <span className="stock-status out-stock mb-0">
                                Out of stock
                              </span>
                            </td>
                          ) : (
                            <td className="row_stock" key={index}>
                              <span className="stock-status in-stock mb-0">
                                In Stock
                              </span>
                            </td>
                          )
                        )}
                    </tr>
                    {/* <tr className="pr_add_to_cart">
                      <td className="text-muted font-sm fw-600 font-heading">
                        Buy now
                      </td>
                      {products &&
                        products?.length > 1 &&
                        products?.map((item, index) =>
                          item?.stock === 0 ? (
                            <td className="row_btn" key={index}>
                              <button className="btn btn-sm btn-secondary" onClick={handleContactNavigation}>
                                <i className="fi-rs-headset mr-5" />
                                Contact Us
                              </button>
                            </td>
                          ) : (
                            <td className="row_btn" key={index}>
                              <button className="btn btn-sm" onClick={()=>handleAddToCart()}>
                                <i className="fi-rs-shopping-bag mr-5" />
                                Add to cart
                              </button>
                            </td>
                          )
                        )}
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
